// @core/api/endpoints/authn/list_public_oauth2_providers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListPublicOAuth2ProvidersResponse,
} from '../../../types/authn';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/authn';

/**
 * List public OAuth2 providers
 * Returns enabled OAuth2 providers with public info (name, icon, type) for displaying login buttons. No authentication required.
 * @public This endpoint does not require authentication
 */
export async function ListPublicOAuth2Providers(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListPublicOAuth2ProvidersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/providers/public`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<ListPublicOAuth2ProvidersResponse>(requestPath, { ...requestOptions, params });
}
